<template>
  <section class="sku_section sku-buy-type">
    <div class="section_title">
      <span class="title">购买方式</span>
    </div>
    <div class="section_content">
      <div
        class="sku_btn"
        v-for="(buyType, idx) in butTypeList"
        :key="'idx' + idx"
        :class="{
          'sku_btn--checked': buyType.id == type
        }"
        @click="selectBuyType(buyType)"
      >
        <span
          tabindex="0"
          :aria-label="
            buyType.id == type
              ? '已选中,' + buyType.name + (buyType.id == 2 && maxReward ? ',' + maxReward : '')
              : '未选中,' + buyType.name + (buyType.id == 2 && maxReward ? ',' + maxReward : '') + ',点按两次可选中'
          "
        >
          {{ buyType.name }}
        </span>
        <span class="badge" v-if="buyType.id == 2 && maxReward" aria-hidden="true">
          <i class="text">{{ maxReward }}</i>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SkuBuyType',
  props: {
    type: Number,
    trackData: Object
  },
  data() {
    return {
      // 防重点
      butTypeList: [
        {
          id: 1,
          name: '立即购买'
        },
        {
          id: 2,
          name: '以旧换新'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('detailv3', ['maxReward'])
  },
  methods: {
    // 调整购买数量
    selectBuyType(type) {
      if (type.id !== this.type) {
        this.$emit('typeChange', type.id)
      }
      // 点击埋点
      let data = this.trackData
      data.button = type.name
      this.$track(data)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
